import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import ContactForm from "./contact-form";
import SuccessStep from "./success-step";
import { stepNames } from "@/constants/emlakjet-link";
import { formGTMEventGA4 } from "@/src/helpers/google-tag-manager/common";
import ErrorStep from "src/components/emlakjet-link/contact-form-modal/error-step";

const Modal = dynamic(() => import("components/common/modal"), { ssr: false });

const ContactFormModal = ({
  isOpen,
  handleClose,
  currentCompany,
  isEmlakjetLink = false,
  isProjectRadar = false,
  project = {},
  logo,
  icon,
  isResponsive = false,
  projectDetailFormData = null,
  isProjectDetailSticky = false,
}) => {
  const { INITIAL, SUCCESS, ERROR } = stepNames;
  const [currentStep, setCurrentStep] = useState(INITIAL);
  const [samePersonError, setSamePersonError] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);

  const handleStep = ({ step, error, phoneNumber }) => {
    const { status_code: statusCode, error: message } = error || {};
    setCurrentStep(step);
    if (statusCode === 412) {
      setSamePersonError(message);
      setPhoneNumber(phoneNumber);
    }
  };

  const handleGoBack = () => {
    setCurrentStep(INITIAL);
    if (samePersonError) {
      formGTMEventGA4({ eventName: "yatirimci-siniri", eventParameters: { label: phoneNumber } });
    }
  };

  useEffect(() => {
    if (isOpen) {
      setCurrentStep(INITIAL);
    }
    return () => {
      setCurrentStep(INITIAL);
      setSamePersonError(null);
    };
  }, [isOpen]);

  const steps = {
    [INITIAL]: (
      <ContactForm
        handleStep={handleStep}
        currentCompany={currentCompany}
        isEmlakjetLink={isEmlakjetLink}
        companyLogo={logo}
        icon={icon}
        projectDetailFormData={projectDetailFormData}
        isProjectRadar={isProjectRadar}
        project={project}
        isProjectDetailSticky={isProjectDetailSticky}
      />
    ),
    [SUCCESS]: (
      <SuccessStep
        projectDetailFormData={projectDetailFormData}
        isProjectRadar={isProjectRadar}
        project={project}
        isProjectDetailSticky={isProjectDetailSticky}
      />
    ),
    [ERROR]: <ErrorStep goBack={handleGoBack} samePersonError={samePersonError} />,
  };

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} onlyCloseClickedButton isResponsive={isResponsive}>
      {steps[currentStep]}
    </Modal>
  );
};

ContactFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  currentCompany: PropTypes.oneOfType([PropTypes.object, PropTypes.number]).isRequired,
  isEmlakjetLink: PropTypes.bool,
  logo: PropTypes.string,
  icon: PropTypes.node,
  isResponsive: PropTypes.bool,
  isProjectRadar: PropTypes.bool,
  projectDetailFormData: PropTypes.string,
  isProjectDetailSticky: PropTypes.bool,
  project: PropTypes?.object,
};

export default ContactFormModal;
